export default "__VITE_ASSET__7b9443bf__"